import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-python';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { View } from 'react-native';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';

const AppCodeEditor = _ref => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3;
  let {
    value,
    setValue = "",
    onChange = () => {},
    inputStyle = {},
    height = 400,
    showTextInputLabel = false,
    label = "",
    labelStyle = {},
    isMandatory = false,
    wrapperStyle = {},
    textInputLabelStyle = {},
    ...props
  } = _ref;
  const {
    currentTheme,
    mode
  } = useTheme();
  return /*#__PURE__*/React__default.createElement(View, null, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    style: [{
      marginLeft: 10,
      marginTop: 10,
      marginBottom: 5
    }, textInputLabelStyle],
    isMandatory: isMandatory,
    label: label
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.inputBackgroundColor,
      borderRadius: 10,
      borderWidth: 1,
      border: "1px solid ".concat(currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.border),
      paddingLeft: 10,
      paddingTop: 10,
      paddingBottom: 10,
      ...wrapperStyle
    },
    className: "tf-code-editor-".concat(mode)
  }, /*#__PURE__*/React__default.createElement(Editor, _extends({
    value: value,
    onValueChange: code => {
      setValue(code);
      onChange(code);
    },
    highlight: code => highlight(code, languages.python),
    style: {
      fontFamily: '"Fira code", "Fira Mono", monospace',
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.small_font_size,
      overflow: "auto",
      minHeight: 360,
      ...inputStyle
    }
  }, props))));
};
AppCodeEditor.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppCodeEditor",
  "props": {
    "setValue": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "inputStyle": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "400",
        "computed": false
      },
      "required": false
    },
    "showTextInputLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false
    },
    "labelStyle": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    },
    "isMandatory": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "wrapperStyle": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    },
    "textInputLabelStyle": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppCodeEditor as A };
